import React, {Component} from 'react'
import clip from './assets/videos/third_quinco_mental.mp4';
import first from './assets/images/quinco_mental1.jpg';
import second from './assets/images/quinco_mental2.jpg';
import third from './assets/images/quinco_mental3.jpeg';
import fourth from './assets/images/quinco_mental4.png';
import videoposter from './assets/images/videoposter.jpg';
import Chocolat from 'chocolat';
import { Link, NavLink } from 'react-router-dom'
import { motion } from 'framer-motion'
import About from "./assets/components/aboutsection";
import Footer from "./assets/components/footer";
import LazyLoad from "vanilla-lazyload";

function lightbox(){ 
document.addEventListener("DOMContentLoaded", function(event) {
        Chocolat(document.querySelectorAll('.chocolat-image'), {
    		closeOnBackgroundClick: true,
    		allowZoom: true
})
      })
}

lightbox();

const transition = { duration: 1.4, ease: [0.17, 0.67, 0.83, 0.67] };


class third_quinco_mental extends Component {
  render() {
    return (
      <div>

        <h1 className="main-title"><Link to="/">Columbus</Link></h1>
        <div className="wrapper">

       <video autoPlay loop muted className="wrapper__video" data-src={clip} poster={videoposter}>
          <source src={clip} type="video/mp4">
          </source>
       </video>
       <div className="page-content">
         <div className="content-wrapper">

         <h1 className="page-heading">Quinco's Mental Health Center</h1>
         <p>This brutalist masterpiece is the work of renowned architect and AIA Gold Medalist, 
         James Stewart Polshek. Jin talked to Casey (35:09) about Polshek's idea for the building 
         and how he thought architecture is a healing art which has the power to restore and architects 
         should be responsible for that. This is especially poignant because this building is a mental health facility.
         </p>

       </div>
       <h3>1972, James Stewart Polshek</h3>
       <h3>2975 Lincoln Park Drive</h3>
       </div>

        </div>

        <div className="gallery">

          <div className="heading">
            <h1>Gallery</h1>
          </div>

              <div className="image-container">
                  <a className="chocolat-image" href={first} title="Copyright owned by Steve Risting - https://dnissen-wpengine.netdna-ssl.com/wp-content/uploads/2016/09/health-services-5.jpg">
                      <img src={first} />
                  </a>
                  <a className="chocolat-image" href={second} title="Quinco Mental Health Centre, Columbus, Indiana 1969 - https://www.pinterest.co.uk/pin/145874475407266346/">
                     <img src={second} />
                  </a>
                  <a className="chocolat-image" href={third} title="Quinco Mental Health Center, Columbus, Indiana 1969 - https://twitter.com/areasvellas/status/1290574681863487489">
                     <img src={third} />
                  </a>
                  <a className="chocolat-image" href={fourth} title="Screenshot from Columbus">
                     <img src={fourth} />
                  </a>
              </div>

        </div>

        <About />

          <Footer />
          </div>
    )
  }
}

export default third_quinco_mental;
